export default __webpack_public_path__ + "static/media/snackKeto.8824ccc6.svg";